'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var collapseAll = function collapseAll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$property = _ref.property,
      property = _ref$property === undefined ? 'showingChildren' : _ref$property;

  return function (rows) {
    return rows.map(function (row) {
      return _extends({}, row, _defineProperty({}, property, false));
    });
  };
};

exports.default = collapseAll;